/**
 * UwPoliceErhaltenDialog - record the received police with its Nummer (P2 Slice 14 D5). From a status
 * before deckungsbestaetigt the intermediate steps are stamped implicitly.
 */

import { useEffect, useState } from 'react';
import { Dialog } from '../administration/components';
import { Button } from '../../components/ui/Button';
import type { UnderwritingResponse, UwPoliceErhaltenBody } from '@brokly/shared';

const inputCls = 'w-full rounded-md border bg-card px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring';

const ERROR_TEXT: Record<string, string> = {
  policy_number_required: 'Bitte die Policennummer angeben',
  antrag_status_invalid: 'Der Antrag ist nicht mehr in diesem Status',
  policy_subject_mismatch: 'Diese Policennummer gehoert zu einer Police eines anderen Kunden - bitte Nummer pruefen',
  policy_already_linked: 'Diese Police ist bereits einer anderen Ausschreibung zugeordnet',
};

export function UwPoliceErhaltenDialog({
  open,
  onClose,
  facts,
  onSubmit,
  saving,
  error,
}: {
  open: boolean;
  onClose: () => void;
  facts: UnderwritingResponse;
  onSubmit: (body: UwPoliceErhaltenBody) => void;
  saving: boolean;
  error: string | null;
}) {
  const [nummer, setNummer] = useState('');
  useEffect(() => {
    if (open) setNummer('');
  }, [open]);

  const status = facts.antrag?.status;
  const implizit = status === 'eingereicht' || status === 'angenommen';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Police erhalten erfassen"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={saving}>Zurueck</Button>
          <Button onClick={() => onSubmit({ policy_number: nummer.trim(), communication_id: facts.carrier_reply?.communication_id ?? null })} disabled={saving || nummer.trim().length < 1} data-testid="uw-police-erhalten-submit">
            Police erhalten erfassen
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3" data-testid="uw-police-erhalten-dialog">
        {implizit && <p className="text-sm text-muted-foreground" data-testid="uw-police-implizit-note">Annahme und Deckungsbestaetigung werden implizit erfasst</p>}
        <label className="text-sm">
          Policennummer
          <input value={nummer} onChange={(e) => setNummer(e.target.value)} className={inputCls} data-testid="uw-police-nummer" />
        </label>
        {error && <p role="alert" className="text-sm text-status-danger" data-testid="uw-police-erhalten-error">{ERROR_TEXT[error] ?? error}</p>}
      </div>
    </Dialog>
  );
}
